module.exports = __webpack_public_path__ + "static/media/facebook.06468580.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.svg
// module id = 437
// module chunks = 0